/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Sidebar_ImprintInputs */

const en_admin_sidebar_imprint = /** @type {(inputs: Admin_Sidebar_ImprintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imprint`)
};

const de_admin_sidebar_imprint = /** @type {(inputs: Admin_Sidebar_ImprintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impressum`)
};

/**
* | output |
* | --- |
* | "Imprint" |
*
* @param {Admin_Sidebar_ImprintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_sidebar_imprint = /** @type {((inputs?: Admin_Sidebar_ImprintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Sidebar_ImprintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_sidebar_imprint(inputs)
	return en_admin_sidebar_imprint(inputs)
});